module.exports = __webpack_public_path__ + "media/img/rathmer-e8d73b99f42cf337305a82f0f237b1ea.jpg";